
    import { Component, Prop, Watch, Vue } from 'nuxt-property-decorator';
    import { namespace } from 'nuxt-property-decorator';
    import ImageComponent from '@/components/blocks/ImageComponent.vue';

    const editor = namespace('editor');

    @Component({
        components: { ImageComponent }
    })
    export default class OptionsFieldsImage extends Vue {
        @Prop() title;
        @Prop() value!: any;
        @Prop() keyOption;
        @Prop() onlyFile;
        @editor.Mutation setComponent;
        @editor.Action loadFile;

        image = { ...this.value };

        showCopyMessage = false;

        @Watch('image', { immediate: true, deep: true })
        onImageChanged(val, oldVal) {
            this.$emit('input', val);
        }

        @Watch('value', { immediate: true, deep: true })
        onValueChanged(val, oldVal) {
            if (oldVal && val && val.src !== oldVal.src) {
                this.image = val;
            }
        }

        async change(file) {
            let data = new FormData();
            data.append('file', file, file.name);
            data.append('isOnEdit', 'true');
            data.append('isOnPublish', 'false');
            data.append('pageId', this.$route.params.id);
            const payload = { data, image: this.image };
            const response = await this.loadFile(payload);
            this.image.src = response['file'];
            this.image.thumbnail = response['thumbnail'];
            this.image.small = response['small'];
            this.image.medium = response['medium'];
        }

        set file(file) {
            this.change(file);
        }

        get file() {
            return '';
        }

        clearImage() {
            this.image = {
                src: '',
                title: '',
                alt: '',
                thumbnail: '',
                size: '',
                small: ''
            };
        }

        get isVideo() {
            return this.image.src.indexOf('.mp4') !== -1;
        }

        copyToClipboard(text: string) {
            // Create a temporary text area element to hold the text
            const textArea = document.createElement('textarea');

            // Set the text area's value to the text to be copied
            textArea.value = text;

            // Prevent the text area from appearing in the user's viewport
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';

            // Append the text area to the document
            document.body.appendChild(textArea);

            // Select the text
            textArea.select();

            try {
                // Copy the selected text to the clipboard
                document.execCommand('copy');
                console.log('Text copied to clipboard');
            } catch (err) {
                console.error('Failed to copy text', err);
            }

            // Remove the text area from the document
            document.body.removeChild(textArea);

            this.$bvToast.show('copy-toast');

            setTimeout(() => {
                this.$bvToast.hide('copy-toast');
            }, 2000);
        }
    }
